import React from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../../../components/dashboard/dashboardHeader";
import { ChecklistCreate } from "../../../quality/checklists/checklist-create";

/**
 * HSE/KS Checklist Create - Ny sjekkliste (ISO 9001:2015 kap. 8.5)
 */
export const HseKsChecklistCreate = () => {
  const { t } = useTranslation();

  return (
    <DashboardHeader
      title="Ny sjekkliste"
      subtitle="Opprett ny sjekkliste (ISO 9001:2015 - kap. 8.5)"
    >
      <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
          <ChecklistCreate />
        </div>
      </div>
    </DashboardHeader>
  );
};

